import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import validator from "validator";
import SignatureCanvas from 'react-signature-canvas';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Tooltip from "@mui/material/Tooltip"

const SignUpLayer = () => {
  const imagePath = `${process.env.PUBLIC_URL}/assets/images/auth/auth-img.png`;
  const imagePath2 = `${process.env.PUBLIC_URL}/assets/images/logo.png`;

  const BaseUrl = process.env.REACT_APP_API;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isDisable, setDisable] = useState(false);
  const [signatureURL, setSignatureURL] = useState('');
  const [strength, setStrength] = useState(0);
  const [email, setEmail] = useState("");
  const [isValidEmail, setValidEmail] = useState(true);
  const [isBlacklistedName, setBlacklistedNameExists] = useState(false);
  const [emailExists, setEmailExists] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);


  const [form, setForm] = useState({
    full_legal_name: "",
    other_names_used: "",
    date_of_birth: "",
    place_of_birth: "",
    nationality: "",
    passport_number: "",
    passport_issue_date: "",
    passport_expiry_date: "",
    passport_issue_place: "",
    national_id_number: "",
    national_id_issue_date: "",
    national_id_expiry_date: "",
    national_id_issue_place: "",
    type_of_account: "",
    nature_of_account: "",
    anticipated_volume: "",
    source_of_funds: "",
    occupation: "",
    employer_name: "",
    reason_for_opening_account: "",
    pep: "",
    pep_name: "",
    position_held: "",
    full_permanent_address: "",
    telephone: "",
    fax: "",
    email: "",
    password: "",
    passport_copy: null,
    national_id: null,
    other_documents: null,
    acting_on_my_behalf: "",
    information_true: "",
    notify_on_change: "",
    signatory_name: "",
    digital_signature: "",
    declaration_date: ""
  });
// const validateCurrentStep = () => {
//   if (currentStep === 1) {
//     const requiredFields = [
//       { key: "full_legal_name", label: "Full Legal Name" },
//       { key: "date_of_birth", label: "Date of Birth" },
//       { key: "place_of_birth", label: "Place of Birth" },
//       { key: "nationality", label: "Nationality" },
//       { key: "passport_number", label: "Passport Number" },
//       { key: "passport_issue_date", label: "Passport Issue Date" },
//       { key: "passport_expiry_date", label: "Passport Expiry Date" },
//       { key: "passport_issue_place", label: "Passport Issue Place" },
//       { key: "national_id_number", label: "National ID Number" },
//       { key: "national_id_issue_date", label: "National ID Issue Date" },
//       { key: "national_id_expiry_date", label: "National ID Expiry Date" },
//       { key: "national_id_issue_place", label: "National ID Issue Place" },
//       { key: "type_of_account", label: "Type of Account" },
//       { key: "nature_of_account", label: "Nature of Account" },
//       { key: "anticipated_volume", label: "Anticipated Volume" },
//       { key: "source_of_funds", label: "Source of Funds" },
//       { key: "occupation", label: "Occupation" },
//       { key: "employer_name", label: "Employer Name" },
//       { key: "reason_for_opening_account", label: "Reason for Opening Account" },
//     ];

//     for (let field of requiredFields) {
//       if (!form[field.key]) {
//         toast.error(`Please enter your ${field.label}`);
//         return false;
//       }
//     }

//     if (isBlacklistedName) {
//       toast.error("Cannot proceed with a blacklisted name.");
//       return false;
//     }
//   }

//   if (currentStep === 2) {
//     if (!form.full_permanent_address) {
//       toast.error("Please enter your Full Permanent Address.");
//       return false;
//     }
//     if (!form.telephone) {
//       toast.error("Please enter your Telephone number.");
//       return false;
//     }
//     if (!form.email || !isValidEmail || emailExists) {
//       toast.error("Please provide an email address.");
//       return false;
//     }
//     if (!form.password || strength < 2) {
//       toast.error("Please provide a password.");
//       return false;
//     }
//   }

//   if (currentStep === 3) {
//     if (!form.passport_copy) {
//       toast.error("Please upload your Passport Copy.");
//       return false;
//     }
//     if (!form.national_id) {
//       toast.error("Please upload your National ID.");
//       return false;
//     }
//     if (!form.other_documents) {
//       toast.error("Please upload the required Other Documents.");
//       return false;
//     }
//   }

//   return true;
// };
// const nextStep = () => {
//   if (validateCurrentStep()) {
//     if (currentStep < 4) {
//       setCurrentStep(currentStep + 1);
//     }
//   }
// };
  const nextStep = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, files, checked } = e.target;
    if (type === "file") {
      setForm({
        ...form,
        [name]: files[0]
      });
    } else if (type === "checkbox") {
      setForm({
        ...form,
        [name]: checked ? 1 : 0
      });
    } else {
      setForm({
        ...form,
        [name]: value
      });
    }
  };

  // const handleFileChange = (e) => {
  //   const { name, files } = e.target;
  //   const maxSize = 10 * 1024 * 1024;

  //   if (files.length === 0) {
  //     setForm({
  //       ...form,
  //       [name]: null,
  //     });
  //     return;
  //   }

  //   if (files[0].type !== "application/pdf") {
  //     alert("Only PDF files are allowed.");
  //     e.target.value = null;
  //     setForm({
  //       ...form,
  //       [name]: null,
  //     });
  //     return;
  //   }

  //   if (files[0].size > maxSize) {
  //     alert("File size exceeds 10 MB. Please select a smaller file.");
  //     e.target.value = null;
  //     setForm({
  //       ...form,
  //       [name]: null,
  //     });
  //   } else {
  //     setForm({
  //       ...form,
  //       [name]: files[0],
  //     });
  //   }
  // };
  
  const handleFileChange = (e) => {
  const { name, files } = e.target;
  const maxSize = 5 * 1024 * 1024; // 5 MB

  if (files.length === 0) {
    setForm({
      ...form,
      [name]: null,
    });
    return;
  }

  const file = files[0];
  const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];

  // Validate file type
  if (!allowedTypes.includes(file.type)) {
    alert("Only PDF, JPG, and PNG files are allowed.");
    e.target.value = null;
    setForm({
      ...form,
      [name]: null,
    });
    return;
  }

  // Validate file size
  if (file.size > maxSize) {
    alert("File size exceeds 5 MB. Please select a smaller file.");
    e.target.value = null;
    setForm({
      ...form,
      [name]: null,
    });
    return;
  }

  // Save file
  setForm({
    ...form,
    [name]: file,
  });
  };

  const handleEmailChange = (event) => {
    const newEmail = event.target.value;
    const regex = /\+[^\@]*@gmail\.com$/;
    const isValidEmail = !regex.test(newEmail);
    setEmail(newEmail);
    setValidEmail(validator.isEmail(newEmail) && isValidEmail);
  };

  const handleCombinedChange = async (e) => {
    handleChange(e);
    handleEmailChange(e);

    await new Promise((resolve) => setTimeout(resolve, 0));

    const email = e.target.value;
    try {
      const response = await axios.get(`${BaseUrl}/individual-email-check?Email=${email}`);
      const { EmailExists } = response.data;
      setEmailExists(EmailExists);
    } catch (error) {
      console.error("Error checking email:", error);
    }
  };


  const handleBlacklistedNameChange = async (e) => {
    handleChange(e)

    await new Promise((resolve) => setTimeout(resolve, 0));

    const full_legal_name = e.target.value;
    try {
      const response = await axios.get(`${BaseUrl}/blaclisted-name-check?name=${full_legal_name}`);
      const { BlacklistedNameExists } = response.data;
      setBlacklistedNameExists(BlacklistedNameExists);
    } catch (error) {
      console.error("Error checking email:", error);
    }
  };

  const calculatePasswordStrength = (password) => {
    let score = 0;
    if (password.length >= 8) score++;
    if (/\d/.test(password)) score++;
    if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score++;
    if (/[!@#$%^&*()_+{}\[\]:;<>,.?~\\|\-=]/.test(password)) score++;
    setStrength(score);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const sigPad = useRef({});
  const [trimmedDataURL, setTrimmedDataURL] = useState(null);

  const clear = () => {
    sigPad.current.clear();
    setTrimmedDataURL(null);
  };

  const trim = () => {
    const canvas = sigPad.current.getTrimmedCanvas();
    canvas.toBlob((blob) => {
      setTrimmedDataURL(URL.createObjectURL(blob)); // For local preview or use as needed
  
      // Update the form state with the blob
      setForm({
        ...form,
        digital_signature: blob
      });
    }, 'image/png');
  };

  const handleSubmit = async (e) => {
       e.preventDefault();

   // 1. Show processing toast

    toast.dismiss();
    const processingToast = toast.loading("Processing...");

    // 2. Define required fields (Updated to ensure Step 4 fields are present)
    const requiredFields = [
      // Step 1
      { field: "full_legal_name", label: "Full Legal Name" },
      { field: "date_of_birth", label: "Date of Birth" },
      { field: "place_of_birth", label: "Place of Birth" },
      { field: "nationality", label: "Nationality" },
      { field: "passport_number", label: "Passport Number" },
      { field: "passport_issue_date", label: "Passport Issue Date" },
      { field: "passport_expiry_date", label: "Passport Expiry Date" },
      { field: "passport_issue_place", label: "Passport Issue Place" },
      { field: "national_id_number", label: "National ID Number" },
      { field: "national_id_issue_date", label: "National ID Issue Date" },
      { field: "national_id_expiry_date", label: "National ID Expiry Date" },
      { field: "national_id_issue_place", label: "National ID Issue Place" },
      { field: "type_of_account", label: "Type of Account" },
      { field: "nature_of_account", label: "Purpose/type of Financial Activity" },
      { field: "anticipated_volume", label: "Anticipated Volume" },
      { field: "source_of_funds", label: "Source of Funds" },
      { field: "occupation", label: "Occupation" },
      { field: "employer_name", label: "Employer Name" },
      { field: "reason_for_opening_account", label: "Reason for Opening Account" },

      // Step 2
      { field: "full_permanent_address", label: "Full Permanent Address" },
      { field: "telephone", label: "Telephone" },
      { field: "email", label: "Email" },
      { field: "password", label: "Password" },

      // Step 3
      { field: "passport_copy", label: "Passport Copy" },
      { field: "national_id", label: "National ID Document" },
      { field: "other_documents", label: "Other Documents" },

      // Step 4 (The Declarations & Signature)
    
      { field: "signatory_name", label: "Signatory Name" }, 
      { field: "digital_signature", label: "Digital Signature" }, 
      { field: "declaration_date", label: "Declaration Date" }, 
    ];

    // 3. Validation Logic
    const missingField = requiredFields.find(
      (item) => !form[item.field] || form[item.field] === "" || form[item.field] === 0
    );

    if (missingField) {
      toast.dismiss(processingToast); // Remove the loading spinner
      toast.error(`${missingField.label} is required`);
      return; // Stop the submission
    }


    setLoading(true);
    try {
      const formData = new FormData();
      Object.keys(form).forEach((key) => {
        formData.append(key, form[key]);
      });

      const response = await axios.post(`${BaseUrl}/submitIndividualInfo`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setLoading(false);
      if (response.data.status === "success") {
        const token = response.data.token;
        if (token) {
          sessionStorage.setItem("authToken", token);
        }
        toast.success("Registration completed successfully!");
        navigate("/dashboard");
      }
    } catch (err) {
      setLoading(false);
      console.error("Error submitting the form:", err);
      toast.error("Registration failed. Please try again.");
    }
  };

  return (
    <section className='auth bg-base d-flex flex-wrap' style={{ width: '100%', margin: '0 auto', padding: '0 20px' }}>
      <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center' style={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
        <div className=' mx-auto w-100'>
          <div>
            <Link to='/' className='mb-40 max-w-290-px'>
              <img src={imagePath2} alt='' />
            </Link>
            <h4 className='mb-12'>Sign Up to your Account</h4>
            <p className='mb-32 text-secondary-light text-lg'>
              Welcome back! please enter your detail
            </p>
          </div>
          <form onSubmit={handleSubmit}>
            {/* Wizard Steps */}
            <div className='form-wizard'>
              <div className='form-wizard-header overflow-x-auto scroll-sm pb-8 my-32'>
                <ul className='list-unstyled form-wizard-list style-two'>
                  <li
                    className={`form-wizard-list__item
                      ${[2, 3, 4].includes(currentStep) && "activated"}
                    ${currentStep === 1 && "active"} `}
                  >
                    <div className='form-wizard-list__line'>
                      <span className='count'>1</span>
                    </div>
                    <span className='text text-xs fw-semibold'>
                    Basic Info
                    </span>
                  </li>
                  <li
                    className={`form-wizard-list__item
                      ${[3, 4].includes(currentStep) && "activated"}
                    ${currentStep === 2 && "active"} `}
                  >
                    <div className='form-wizard-list__line'>
                      <span className='count'>2</span>
                    </div>
                    <span className='text text-xs fw-semibold'>
                    Contact Info
                    </span>
                  </li>
                  <li
                    className={`form-wizard-list__item
                      ${[4].includes(currentStep) && "activated"}
                    ${currentStep === 3 && "active"} `}
                  >
                    <div className='form-wizard-list__line'>
                      <span className='count'>3</span>
                    </div>
                    <span className='text text-xs fw-semibold'>KYC Documents</span>
                  </li>
                  <li
                    className={`form-wizard-list__item
                    ${currentStep === 4 && "active"} `}
                  >
                    <div className='form-wizard-list__line'>
                      <span className='count'>4</span>
                    </div>
                    <span className='text text-xs fw-semibold'>Declaration</span>
                  </li>
                </ul>
              </div>

              {/* Step 1: Personal Information */}
              <fieldset className={`wizard-fieldset ${currentStep === 1 && "show"} `}>
                <h6 className='text-md text-neutral-500'>
                Basic Info
                </h6>
                <div className='form-group mb-16'>
                  <label htmlFor='full_legal_name'    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>Full Legal Name *
                           <Tooltip
                      title="Enter your full legal name exactly as it appears on your government-issued identity document (e.g., Passport, National ID)."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip></label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:person' />
                    </span>
                    <input
                      type='text'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='full_legal_name'
                      name='full_legal_name'
                      value={form.full_legal_name}
                      onChange={handleBlacklistedNameChange}
                      //required
                    />
                  
                  </div>
                  {isBlacklistedName && (
                      <p className='text-danger mt-2'>Blacklisted Name Detected</p>
                    )}
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='other_names_used' style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>Other Names Used
                      <Tooltip
                      title="Provide any previous names, aliases, maiden names, or alternative spellings that the entity has been officially registered under in the past.
                      (Leave blank if not applicable.)
                      "
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                    
                    </label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:person' />
                    </span>
                    <input
                      type='text'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='other_names_used'
                      name='other_names_used'
                      value={form.other_names_used}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='date_of_birth'
                  style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>Date of Birth *
                       <Tooltip
                      title="Select your date of birth exactly as it appears on your official identification documents."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                    
                    
                    </label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:calendar' />
                    </span>
                    <input
                      type='date'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='date_of_birth'
                      name='date_of_birth'
                      value={form.date_of_birth}
                      onChange={handleChange}
                      //required
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='place_of_birth'
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>Place of Birth *
                    <Tooltip
                      title="Enter the city and country of birth as stated in your passport or birth certificate."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                    </label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:location' />
                    </span>
                    <input
                      type='text'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='place_of_birth'
                      name='place_of_birth'
                      value={form.place_of_birth}
                      onChange={handleChange}
                      //required
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='nationality'   style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>Nationality *
                        <Tooltip
                      title="Specify your current nationality or citizenship as stated in your official identification documents."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip></label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:flag' />
                    </span>
                    <input
                      type='text'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='nationality'
                      name='nationality'
                      value={form.nationality}
                      onChange={handleChange}
                      //required
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='passport_number' >Passport Number *
                   
                    </label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:doc' />
                    </span>
                    <input
                      type='text'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='passport_number'
                      name='passport_number'
                      value={form.passport_number}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='passport_issue_date'>Passport Issue Date *</label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:calendar' />
                    </span>
                    <input
                      type='date'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='passport_issue_date'
                      name='passport_issue_date'
                      value={form.passport_issue_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='passport_expiry_date'>Passport Expiry Date *</label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:calendar' />
                    </span>
                    <input
                      type='date'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='passport_expiry_date'
                      name='passport_expiry_date'
                      value={form.passport_expiry_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='passport_issue_place' style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>Passport Issue Place *
                       <Tooltip
                      title="Enter the city and country where your passport was issued, as stated in the passport."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                    
                    
                    
                    </label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:location' />
                    </span>
                    <input
                      type='text'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='passport_issue_place'
                      name='passport_issue_place'
                      value={form.passport_issue_place}
                      onChange={handleChange}
                    />
                  </div>
                </div>

        <div className='form-group mb-16'>

  <label 
    htmlFor='national_id_number' 
    style={{
      display: "flex",
      alignItems: "center",
      gap: "4px",
      marginBottom: "8px" 
    }}
  >
    National ID Number *
    <Tooltip
      title="Provide your government-issued National Identification Number (e.g., Aadhaar, SSN, National ID) as per your official identification documents."
      arrow
      placement="top"
    >
      <span style={{ cursor: "pointer", display: "flex" }}>
        <Icon
          icon="lucide:info"
          width="16"
          height="16"
          className="text-secondary-light"
        />
      </span>
    </Tooltip>
  </label>

  <div className='icon-field'>
    <span className='icon top-50 translate-middle-y'>
      <Icon icon='f7:doc' />
    </span>
    <input
      type='text'
      className='form-control h-56-px bg-neutral-50 radius-12'
      id='national_id_number'
      name='national_id_number'
      value={form.national_id_number}
      onChange={handleChange}
    />
  </div>
</div>
                <div className='form-group mb-16'>
                  <label htmlFor='national_id_issue_date' style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>National ID Issue Date *
                         <Tooltip
                      title="Select the issue date of your National ID, as stated on the official identification document."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                    </label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:calendar' />
                    </span>
                    <input
                      type='date'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='national_id_issue_date'
                      name='national_id_issue_date'
                      value={form.national_id_issue_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='national_id_expiry_date' style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>National ID Expiry Date *
                      <Tooltip
                      title="Select the expiry date of your National ID, if applicable. If the ID does not have an expiry, provide the officially stated validity date."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                    
                    </label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:calendar' />
                    </span>
                    <input
                      type='date'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='national_id_expiry_date'
                      name='national_id_expiry_date'
                      value={form.national_id_expiry_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='national_id_issue_place' style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>National ID Issue Place *
                           <Tooltip
                      title="Enter the place of issuance as stated on your National ID."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                    
                    </label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:location' />
                    </span>
                    <input
                      type='text'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='national_id_issue_place'
                      name='national_id_issue_place'
                      value={form.national_id_issue_place}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='type_of_account'style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>Type of Account *
                            {/* <Tooltip
                      title="Select the category of account you wish to open
(e.g., Individual, Joint, Corporate, Investment Account).

"
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip> */}
                    
                    </label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:briefcase' />
                    </span>
                    <select
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='type_of_account'
                      name='type_of_account'
                      value={form.type_of_account}
                      onChange={handleChange}
                      //required
                    >
                      <option value=''>Select Type of Account</option>
                                           <option value='1'>Individual Account </option>
                      <option value='2'>Joint Account</option>
                          <option value='3'>Corporate Account</option>
                      <option value='4'>Investment Account</option>
                    </select>
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='nature_of_account'style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>Purpose/type of Financial Activity *
                    {/* <Tooltip
                      title="Specify the purpose/type of financial activity expected
(e.g., Investment, Trading, Savings, Wealth Management).
"
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip> */}
                    </label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:briefcase' />
                    </span>
                    <select
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='nature_of_account'
                      name='nature_of_account'
                      value={form.nature_of_account}
                      onChange={handleChange}
                      //required
                    >
                      <option value=''>Select Nature of Account</option>
                      <option value='1'>Investment in Equities</option>
                      <option value='2'>Investment in Securities</option>
                      <option value='3'>Investment in Bonds</option>
                      <option value='4'>Investment in Commodities</option>
                      <option value='5'>Investment in Mutual Funds</option>
                      <option value='6'>Investment in Stocks</option>
                      <option value='7'>Investment in Digital Assets</option>
                    </select>
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='anticipated_volume' style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>Anticipated Volume *
                     <Tooltip
                      title="Estimate the expected transaction volume (monthly or annually). This information is required for risk assessment and regulatory compliance purposes."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip></label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:briefcase' />
                    </span>
                    <select
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='anticipated_volume'
                      name='anticipated_volume'
                      value={form.anticipated_volume}
                      onChange={handleChange}
                      //required
                    >
                      <option value=''>Select Anticipated Volume</option>
                      <option value='1'>1 - 100,000 USD</option>
                      <option value='2'>100,000 - 500,000 USD</option>
                      <option value='3'>500,000 - 1,000,000 USD</option>
                      <option value='4'>1,000,000 - 10,000,000 USD</option>
                      <option value='5'>10,000,000 - 50,000,000 USD</option>
                    </select>
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='source_of_funds'>Source of Funds *</label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:briefcase' />
                    </span>
                    <select
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='source_of_funds'
                      name='source_of_funds'
                      value={form.source_of_funds}
                      onChange={handleChange}
                      //required
                    >
                      <option value=''>Select Source of Funds</option>
                      <option value='1'>Salary</option>
                      <option value='2'>Business Activity</option>
                      <option value='3'>Savings</option>
                      <option value='4'>Pension</option>
                      <option value='5'>Inheritance</option>
                      <option value='6'>Gift</option>
                      <option value='7'>Bonus</option>
                      <option value='8'>Indemnity/End of Service Payment</option>
                      <option value='9'>Return on Investments</option>
                      <option value='10'>Other</option>
                    </select>
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='occupation' style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>Occupation *
                    <Tooltip
                      title="Specify your current occupation or professional role as per your official records (e.g., Business Owner, Salaried Professional, Investor, Consultant)."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip></label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:briefcase' />
                    </span>
                    <input
                      type='text'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='occupation'
                      name='occupation'
                      value={form.occupation}
                      onChange={handleChange}
                      //required
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='employer_name' style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>Employer Name *
                      <Tooltip
                      title="Specify your current occupation or professional role. Enter the name of your employer or business. If self-employed, provide your business name as registered or officially recognized."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip></label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:briefcase' />
                    </span>
                    <input
                      type='text'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='employer_name'
                      name='employer_name'
                      value={form.employer_name}
                      onChange={handleChange}
                      //required
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='reason_for_opening_account'style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>Reason for Opening Account *
                    <Tooltip
                      title="Provide a brief explanation of the purpose for opening this account (e.g., investment diversification, asset management, global exposure)."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip></label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:question' />
                    </span>
                    <input
                      type='text'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='reason_for_opening_account'
                      name='reason_for_opening_account'
                      value={form.reason_for_opening_account}
                      onChange={handleChange}
                      //required
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='pep' style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>PEP (Politically Exposed Person)                  
                <Tooltip
                    title={
                      <div style={{ padding: '4px' }}>
                        Indicate whether you or a close associate:
                        <ul style={{ margin: '8px 0 0 0', paddingLeft: '15px', listStyleType: 'disc' }}>
                          <li>Currently hold or have held a **prominent public or political position**</li>
                          <li>Are related to a **politically exposed person (PEP)**</li>
                          <li style={{ marginTop: '4px', fontWeight: 'bold', listStyleType: 'none', marginLeft: '-15px' }}>
                            Select **Yes** or **No** accordingly
                          </li>
                        </ul>
                      </div>
                    }
                    arrow
                    placement="top"
                  >
                    <span style={{ cursor: "pointer", display: "flex" }}>
                      <Icon
                        icon="lucide:info"
                        width="16"
                        height="16"
                        className="text-secondary-light"
                      />
                    </span>
                  </Tooltip>
                    
                    </label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                    </span>
                    <div className='d-flex align-items-center'>
                      <div className='form-check me-3'>
                        <input
                          className='form-check-input'
                          type='radio'
                          id='pep_yes'
                          name='pep'
                          value='1'
                          checked={form.pep === '1'}
                          onChange={handleChange}
                        />
                        <label className='form-check-label' htmlFor='pep_yes'>
                          Yes
                        </label>
                      </div>
                      <div className='form-check'>
                        <input
                          className='form-check-input'
                          type='radio'
                          id='pep_no'
                          name='pep'
                          value='0'
                          checked={form.pep === '0'}
                          onChange={handleChange}
                        />
                        <label className='form-check-label' htmlFor='pep_no'>
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {form.pep === '1' && (
                  <div className='form-group mb-16'>
                    <label htmlFor='pep_name'>PEP Name</label>
                    <div className='icon-field'>
                      <span className='icon top-50 translate-middle-y'>
                        <Icon icon='f7:person' />
                      </span>
                      <input
                        type='text'
                        className='form-control h-56-px bg-neutral-50 radius-12'
                        id='pep_name'
                        name='pep_name'
                        value={form.pep_name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                )}

                {form.pep === '1' && (
                  <div className='form-group mb-16'>
                    <label htmlFor='position_held'>Position Held</label>
                    <div className='icon-field'>
                      <span className='icon top-50 translate-middle-y'>
                        <Icon icon='f7:briefcase' />
                      </span>
                      <input
                        type='text'
                        className='form-control h-56-px bg-neutral-50 radius-12'
                        id='position_held'
                        name='position_held'
                        value={form.position_held}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                )}

                <div className='form-group text-end mt-32'>
                  <button
                    type='button'
                    className='btn btn-primary-600 px-32'
                    onClick={nextStep}
                  >
                    Next
                  </button>
                </div>
              </fieldset>

              {/* Step 2: Contact Information */}
              <fieldset className={`wizard-fieldset ${currentStep === 2 && "show"} `}>
                <h6 className='text-md text-neutral-500'>
                  Contact Info
                </h6>
                <div className='form-group mb-16'>
                  <label htmlFor='full_permanent_address'>Full Permanent Address *</label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:location' />
                    </span>
                    <input
                      type='text'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='full_permanent_address'
                      name='full_permanent_address'
                      value={form.full_permanent_address}
                      onChange={handleChange}
                      //required
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='telephone'>Telephone *</label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:phone' />
                    </span>
                    <input
                      type='tel'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='telephone'
                      name='telephone'
                      value={form.telephone}
                      onChange={handleChange}
                      //required
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='fax'>Fax</label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:person' />
                    </span>
                    <input
                      type='tel'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='fax'
                      name='fax'
                      value={form.fax}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='email'>Email *</label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:person' />
                    </span>
                    <input
                      type='email'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='email'
                      name='email'
                      value={form.email}
                      onChange={handleCombinedChange}
                      //required
                    />
                    
                  </div>
                  {!isValidEmail && (
                      <p className='text-danger mt-2'>Invalid email address</p>
                    )}
                    {emailExists && (
                      <p className='text-danger mt-2'>Email already exists</p>
                    )}
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='password'>Password *</label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:lock' />
                    </span>
                    <input
                      type={showPassword ? "text" : "password"}
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='password'
                      name='password'
                      value={form.password}
                      onChange={(e) => {
                        handleChange(e);
                        calculatePasswordStrength(e.target.value);
                      }}
                      //required
                    />
                 
                  </div>
                  <span
                      className='toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light'
                      onClick={togglePasswordVisibility}
                    />
                    {form.password.length > 0 && (
                      <div className='mt-2'>
                        <p className='text-sm'>
                          Password Strength:{" "}
                          <span
                            className={`${
                              strength === 0
                                ? "text-danger"
                                : strength === 1
                                ? "text-warning"
                                : strength === 2
                                ? "text-info"
                                : "text-success"
                            }`}
                          >
                            {strength === 0
                              ? "Too Weak"
                              : strength === 1
                              ? "Weak"
                              : strength === 2
                              ? "Good"
                              : "Strong"}
                          </span>
                        </p>
                      </div>
                    )}
                </div>

                <div className='form-group text-end mt-32'>
                  <button
                    type='button'
                    className='btn btn-secondary-600 px-32 me-3'
                    onClick={prevStep}
                  >
                    Previous
                  </button>
                  <button
                    type='button'
                    className='btn btn-primary-600 px-32'
                    onClick={nextStep}
                  >
                    Next
                  </button>
                </div>
              </fieldset>

              {/* Step 3: KYC Documents */}
              <fieldset className={`wizard-fieldset ${currentStep === 3 && "show"} `}>
                <h6 className='text-md text-neutral-500'>
                  KYC Documents (Only PDF, JPG, PNG files allowed, max size 5 MB)
                </h6>
                <div className='form-group mb-16'>
                  <label htmlFor='passport_copy'>Passport Copy *</label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:doc' />
                    </span>
                    <input
                      type='file'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='passport_copy'
                      name='passport_copy'
                      onChange={handleFileChange}
                      accept='application/pdf, image/jpeg, image/png'
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='national_id'>National ID *</label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:doc' />
                    </span>
                    <input
                      type='file'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='national_id'
                      name='national_id'
                      onChange={handleFileChange}
                      accept='application/pdf, image/jpeg, image/png'
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='other_documents'>Other Documents *</label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:doc' />
                    </span>
                    <input
                      type='file'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='other_documents'
                      name='other_documents'
                      onChange={handleFileChange}
                      accept='application/pdf, image/jpeg, image/png'
                    />
                  </div>
                </div>

                <div className='form-group text-end mt-32'>
                  <button
                    type='button'
                    className='btn btn-secondary-600 px-32 me-3'
                    onClick={prevStep}
                  >
                    Previous
                  </button>
                  <button
                    type='button'
                    className='btn btn-primary-600 px-32'
                    onClick={nextStep}
                  >
                    Next
                  </button>
                </div>
              </fieldset>

              {/* Step 4: Declaration */}
              <fieldset className={`wizard-fieldset ${currentStep === 4 && "show"} `}>
                <h6 className='text-md text-neutral-500'>
                  Declarations
                </h6>
                <div className='form-group mb-16'>
                  <div className='form-check'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      id='acting_on_my_behalf'
                      name='acting_on_my_behalf'
                      checked={form.acting_on_my_behalf}
                      onChange={handleChange}
                    />
                    <label className='form-check-label' htmlFor='acting_on_my_behalf'>
                      I/We hereby confirm that I/we are acting and would, in future will
                      also be acting on my/our behalf for the purpose of transactions,
                      new accounts or providing any further information required by Blue
                      Aster Capital BSC ©.
                    </label>
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <div className='form-check'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      id='information_true'
                      name='information_true'
                      checked={form.information_true}
                      onChange={handleChange}
                    />
                    <label className='form-check-label' htmlFor='information_true'>
                      I/We hereby confirm the information provided above is true, accurate
                      and complete. Subject to applicable local laws, I/we hereby consent
                      for Blue Aster Capital BSC © or any of its affiliates to share our
                      information with domestic or overseas regulators or tax authorities
                      where necessary.
                    </label>
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <div className='form-check'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      id='notify_on_change'
                      name='notify_on_change'
                      checked={form.notify_on_change}
                      onChange={handleChange}
                    />
                    <label className='form-check-label' htmlFor='notify_on_change'>
                      I/We agree and undertake to notify Blue Aster Capital BSC © within
                      30 calendar days if there is a change in any information which I/we
                      have provided.
                    </label>
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='signatory_name'>Signatory Name *</label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:person' />
                    </span>
                    <input
                      type='text'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='signatory_name'
                      name='signatory_name'
                      value={form.signatory_name}
                      onChange={handleChange}
                      // required
                    />
                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='digital_signature'>Digital Signature *</label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:pencil' />
                    </span>
                    <div
        className="border rounded shadow-sm p-2 bg-light"
        style={{ display: 'inline-block', width: '300px', height: '200px' }}
      >
        <SignatureCanvas
          ref={sigPad}
          penColor="black"
          canvasProps={{
            width: 280,
            height: 180,
            className: 'sigCanvas w-100 h-100',
          }}
          backgroundColor="#fff"
        />
      </div> <br></br>
      <div className="btn-group mt-3">
        <button type="button" className="btn btn-warning" onClick={clear}>
          Clear
        </button>
        <button type="button" className="btn btn-primary" onClick={trim}>
          Save Signature
        </button>
      </div>
      {trimmedDataURL && (
        <div className="mt-3">
          <img src={trimmedDataURL} alt="Your Signature" />
        </div>
      )}  

                  </div>
                </div>

                <div className='form-group mb-16'>
                  <label htmlFor='declaration_date'>Declaration Date *</label>
                  <div className='icon-field'>
                    <span className='icon top-50 translate-middle-y'>
                      <Icon icon='f7:calendar' />
                    </span>
                    <input
                      type='date'
                      className='form-control h-56-px bg-neutral-50 radius-12'
                      id='declaration_date'
                      name='declaration_date'
                      value={form.declaration_date}
                      onChange={handleChange}
                      // required
                    />
                  </div>
                </div>

                <div className='form-group text-end'>
                  <button
                    onClick={prevStep}
                    type='button'
                    className='form-wizard-prev-btn btn btn-secondary-600 px-32'
                  >
                    Previous
                  </button>
                  <button
                    disabled ={isBlacklistedName || emailExists}
                    type='submit'
                    className='form-wizard-next-btn btn btn-primary-600 px-32'
                  >
                  {loading ? (
      <>
        <Icon icon="line-md:loading-twotone-loop" />
        Submitting...
      </>
    ) : (
      "Submit"
    )}
                  </button>
                </div>
              </fieldset>
            </div>
          </form>
        </div>
        <div className='mt-32 text-center text-sm'>
          <p className='mb-0'>
            Already have an account?{" "}
            <Link to='/sign-in' className='text-primary-600 fw-semibold'>
              Sign In
            </Link>
          </p>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </section>
  );
};

export default SignUpLayer;